module.exports = __webpack_public_path__ + "static/media/MATH170S.56694e22.PNG";